//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'ducci_jb',
    colors: ['#395e54', '#e77b4d', '#050006', '#e55486'],
    stroke: '#050006',
    background: '#efe0bc',
    type: 'ducci',
  },
  {
    name: 'ducci_a',
    colors: ['#809498', '#d3990e', '#000000', '#ecddc5'],
    stroke: '#ecddc5',
    background: '#863f52',
    type: 'ducci',
  },
  {
    name: 'ducci_b',
    colors: ['#ecddc5', '#79b27b', '#000000', '#ac6548'],
    stroke: '#ac6548',
    background: '#d5c08e',
    type: 'ducci',
  },
  {
    name: 'ducci_d',
    colors: ['#f3cb4d', '#f2f5e3', '#20191b', '#67875c'],
    stroke: '#67875c',
    background: '#433d5f',
    type: 'ducci',
  },
  {
    name: 'ducci_e',
    colors: ['#c37c2b', '#f6ecce', '#000000', '#386a7a'],
    stroke: '#386a7a',
    background: '#e3cd98',
    type: 'ducci',
  },
  {
    name: 'ducci_f',
    colors: ['#596f7e', '#eae6c7', '#463c21', '#f4cb4c'],
    stroke: '#f4cb4c',
    background: '#e67300',
    type: 'ducci',
  },
  {
    name: 'ducci_g',
    colors: ['#c75669', '#000000', '#11706a'],
    stroke: '#11706a',
    background: '#ecddc5',
    type: 'ducci',
  },
  {
    name: 'ducci_h',
    colors: ['#6b5c6e', '#4a2839', '#d9574a'],
    stroke: '#d9574a',
    background: '#ffc34b',
    type: 'ducci',
  },
  {
    name: 'ducci_i',
    colors: ['#e9dcad', '#143331', '#ffc000'],
    stroke: '#ffc000',
    background: '#a74c02',
    type: 'ducci',
  },
  {
    name: 'ducci_j',
    colors: ['#c47c2b', '#5f5726', '#000000', '#7e8a84'],
    stroke: '#7e8a84',
    background: '#ecddc5',
    type: 'ducci',
  },
  {
    name: 'ducci_o',
    colors: ['#c15e1f', '#e4a13a', '#000000', '#4d545a'],
    stroke: '#4d545a',
    background: '#dfc79b',
    type: 'ducci',
  },
  {
    name: 'ducci_q',
    colors: ['#4bae8c', '#d0c1a0', '#2d3538'],
    stroke: '#2d3538',
    background: '#d06440',
    type: 'ducci',
  },
  {
    name: 'ducci_u',
    colors: ['#f6d700', '#f2d692', '#000000', '#5d3552'],
    stroke: '#5d3552',
    background: '#ff7426',
    type: 'ducci',
  },
  {
    name: 'ducci_v',
    colors: ['#c65f75', '#d3990e', '#000000', '#597e7a'],
    stroke: '#597e7a',
    background: '#f6eccb',
    type: 'ducci',
  },
  {
    name: 'ducci_x',
    colors: ['#dd614a', '#f5cedb', '#1a1e4f'],
    stroke: '#1a1e4f',
    background: '#fbb900',
    type: 'ducci',
  },
];
